import Tr from "translations/Translations";
import {PurchasingGroupTemplateFieldType} from "../../../../../templates/constants/PurchasingGroupTemplateFieldType";
import moment from "../../../../../../../../libs/moment";
import DateFormats from "../../../../../../../../constants/DateFormats";

export default (form) => {
    const transformer = {
        purchaserName: {
            id: 'purchaserName',
            label: Tr('name')
        },
    }

    form.fieldValues.forEach((x, i) => {
        transformer["fieldValue_" + x.identity] = {
            id: `fieldValues.${i}`,
            label: x.name,
            transform: (field) => {
                if (!field)
                    return "";
                if (field.type === PurchasingGroupTemplateFieldType.TEXT) {
                    return field.textValue || "";
                } else if(field.type === PurchasingGroupTemplateFieldType.DATE){
                    return !!field.textValue ? moment(field.textValue).format(DateFormats.DATE_FORMAT) : "";
                } else {
                    if (field.decimalValue != null) {
                        return ("" + field.decimalValue).replace(".", ",") + (field.type === PurchasingGroupTemplateFieldType.PERCENTAGE ? " %" : "")
                    }
                }
            }
        }
    })
    return transformer;
}

export const customParamTransformer = {
    decisionType: {
        id: "decisionType",
        label: Tr('decision'),
        showOnGrid: true,
        transform: (field) => {
            return field ? Tr("decision_type_" + field.toLowerCase()) : null
        }
    }
}
